import { useState } from 'react';
import { AppSidebar } from './components/app-sidebar';
import { SidebarProvider } from '@/components/ui/sidebar';
import { ThemeProvider } from '../hooks/theme-provider';
import { AuthProvider } from '@/context/useAuthStore';
import AppTopbar from './components/app-topbar';
import 'katex/dist/katex.min.css';
import RequireSubscription from '@/hooks/use-subscription';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '@clerk/clerk-react';

export default function Layout({ children }) {
  const navigate = useNavigate();
  const { membership } = useOrganization();
  const savedRole = membership?.roleName?.toLowerCase();
  const [selectedRole, setSelectedRole] = useState(savedRole || 'student');

  const handleSelectRole = (role) => {
    setSelectedRole(role);
    if (role === 'admin') {
      navigate('/admin/dashboard');
    } else if (role === 'teacher') {
      navigate('/teacher/dashboard');
    } else {
      navigate('/student/home');
    }
  };

  return (
    <AuthProvider>
      <RequireSubscription>
        <ThemeProvider defaultTheme="light">
          <SidebarProvider>
            <div className="grid grid-cols-[auto,1fr] w-full h-screen">
              <AppSidebar selectedRole={selectedRole} setSelectedRole={handleSelectRole} />
              <main className="flex flex-col h-full overflow-hidden">
                <AppTopbar />
                <div className="flex-1 overflow-hidden">
                  {children}
                </div>
              </main>
            </div>
          </SidebarProvider>
        </ThemeProvider>
      </RequireSubscription>
    </AuthProvider>
  );
}
